import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  chartWrapper: {
    width: "100%",
    height: 240,
    border: `1px solid ${colour.grey[500]}`,
    borderRadius: 3
  },
  titleWrapper: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    borderBottom: `1px solid ${colour.grey[500]}`,
    paddingBottom: 12,
    paddingTop: 1
  },
  chartTitle: {
    textAlign: "left",
    fontSize: 14,
    fontWeight: 600,
    color: colour.grey[300],
    marginTop: 10,
    marginLeft: 10
  },
  dottedMeaning: {
    position: "relative",
    textAlign: "right",
    color: colour.grey[300],
    fontSize: 12,
    fontWeight: 600,
    marginTop: 10,
    marginRight: 10,
    paddingRight: 25,
    ":after": {
      content: '" "',
      display: "block",
      position: "absolute",
      right: 0,
      top: 9,
      width: 20,
      height: 1,
      borderTop: `1px dashed ${colour.grey[300]}`
    }
  }
});
